import { createSlice } from "@reduxjs/toolkit";

const deviceState = createSlice({
  name: "device",
  initialState: {
    isDeviceAdded: false,
    deviceAdded: {},
    isDeviceUpdated: false,
    listDevices: [],
    isDeviceApproved: false
  },
  reducers: {
    setIsDeviceAdded: (state, action) => {
      state.isDeviceAdded = action.payload;
    },
    setDeviceAdded: (state, action) => {
      state.deviceAdded = action.payload;
    },
    setIsDeviceUpdated: (state, action) => {
      state.isDeviceUpdated = action.payload;
    },
    setListDevice: (state, action) => {
      state.listDevices.push(action.payload);
    },
    setIsDeviceApproved: (state, action) => {
      state.isDeviceApproved = action.payload;
    }

  },
});

export const {
  setIsDeviceAdded,
  setDeviceAdded,
  setIsDeviceUpdated,
  setListDevice,
  setIsDeviceApproved
} = deviceState.actions;
export default deviceState.reducer;
